import { render, staticRenderFns } from "./ProductUpsellSelector.vue?vue&type=template&id=16b8a0b8"
import script from "./ProductUpsellSelector.vue?vue&type=script&lang=js"
export * from "./ProductUpsellSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports